import FixaPill from "../../../wrappers/FixaPill/FixaPill";
import CrossIconPath from "../../../wrappers/FixaSSRIcon/paths/CrossIconPath";
import {
  FilterValue,
  SelectFilter,
  SelectOption,
  StringFilterValue,
} from "../../types/filter";
import {
  getInputFilterValueCount,
  removeFilterValueFromValues,
} from "../../utils/filter/filtervalue";
import {
  isCustomPeriodOption,
  isSelectGroup,
  isSelectOption,
} from "../../utils/filter/selectoption";
import { formatDateByLocale } from "@coworker/reusable/formatters/date.formatter";

const isPeriodFilterValue = (
  filterValue: StringFilterValue
): filterValue is StringFilterValue & { startDate: string; endDate: string } =>
  "startDate" in filterValue && "endDate" in filterValue;

interface AppliedSelectPillProps {
  filter: SelectFilter;
  filterValue: StringFilterValue | undefined;
  filterValues: FilterValue[];
  setFilterValues: (filterValues: FilterValue[]) => void;
}

export const AppliedSelectPill = ({
  filter,
  filterValue,
  filterValues,
  setFilterValues,
}: AppliedSelectPillProps) => {
  const { id, title } = filter;

  if (
    filterValue &&
    getInputFilterValueCount(filterValue, filter.defaultValue)
  ) {
    const option = filter.options
      .flatMap((option) => (isSelectGroup(option) ? option.options : option))
      .filter((option) => isSelectOption(option))
      .find((option) => (option as SelectOption).value === filterValue.value);

    const label = `${title}: ${
      option && isCustomPeriodOption(option) && isPeriodFilterValue(filterValue)
        ? `${formatDateByLocale(filterValue.startDate)} - ${formatDateByLocale(filterValue.endDate)}`
        : (option?.title ?? filterValue.value)
    }`;

    return (
      <FixaPill
        trailingIcon={CrossIconPath}
        selected
        label={label}
        onClick={() => {
          setFilterValues(removeFilterValueFromValues(filterValues, id));
        }}
        size="small"
      />
    );
  } else {
    return null;
  }
};
